module.exports = __webpack_public_path__ + "media/landing_page/city-page-hero-mobile-6f256ff5.webp";